<template>
  <v-form v-model="valid" ref="mainForm">
    <subheadline code="titre-etape-3.1"></subheadline>

    <opq-catalogue
      code="renseignements-analyse-demande"
      v-model="sasInspection3.renseignementsAnalyseDemande"
      :live="liveSasInspection3(12603)"
    ></opq-catalogue>

    <opq-memo code="elements-requis" v-model="sasInspection3.elementsRequis" :live="liveSasInspection3(12604)"></opq-memo>

    <opq-catalogue code="contexte-travail" v-model="sasInspection3.contexteTravail" :live="liveSasInspection3(12605)"></opq-catalogue>

    <opq-memo code="contexte-travail-details" v-model="sasInspection3.contexteTravailDetails" :live="liveSasInspection3(12606)" optional></opq-memo>

    <opq-catalogue code="pertinence-mandat" v-model="sasInspection3.pertinenceMandat" :live="liveSasInspection3(12607)"></opq-catalogue>

    <opq-catalogue code="comprehension-attentes" v-model="sasInspection3.comprehensionAttentes" :live="liveSasInspection3(12608)"></opq-catalogue>

    <opq-memo
      code="comprehension-attentes-details"
      v-model="sasInspection3.comprehensionAttentesDetails"
      :live="liveSasInspection3(12609)"
    ></opq-memo>

    <opq-catalogue code="donnees-a-recueillir" v-model="sasInspection3.donneesARecueillir" :live="liveSasInspection3(12610)"></opq-catalogue>

    <opq-catalogue code="justesse-conclusions" v-model="sasInspection3.justesseConclusions" :live="liveSasInspection3(12611)"></opq-catalogue>

    <opq-catalogue code="suites-appropriees" v-model="sasInspection3.suitesAppropriees" :live="liveSasInspection3(12612)"></opq-catalogue>

    <opq-catalogue code="litterature-scientifique" v-model="sasInspection3.litteratureScientifique" :live="liveSasInspection3(12613)"></opq-catalogue>

    <opq-memo code="litterature-detail" v-model="sasInspection3.litteratureDetail" :live="liveSasInspection3(12614)"></opq-memo>

    <opq-catalogue code="particularites-moyens" v-model="sasInspection3.particularitesMoyens" :live="liveSasInspection3(12615)"></opq-catalogue>

    <opq-catalogue code="systeme-classification" v-model="sasInspection3.systemeClassification" :live="liveSasInspection3(12616)"></opq-catalogue>

    <opq-memo code="manuel-reference" v-model="sasInspection3.manuelReference" :live="liveSasInspection3(12617)"></opq-memo>

    <opq-memo code="conclusions-exemple" v-model="sasInspection3.conclusionsExemple" :live="liveSasInspection3(12618)"></opq-memo>

    <opq-catalogue code="correction-protocole" v-model="sasInspection3.correctionProtocole" :live="liveSasInspection3(12619)"></opq-catalogue>

    <opq-memo code="instruments-mesure" v-model="sasInspection3.instrumentsMesure" :live="liveSasInspection3(12620)"></opq-memo>

    <opq-catalogue code="pertinence_intervention" v-model="sasInspection3.pertinenceIntervention" :live="liveSasInspection3(12621)"></opq-catalogue>

    <opq-catalogue
      code="communication-appropriee-conclusions"
      v-model="sasInspection3.communicationApproprieeConclusions"
      :live="liveSasInspection3(12622)"
    ></opq-catalogue>

    <opq-memo code="difficulte-evaluation-exemple" v-model="sasInspection3.difficulteEvaluationExemple" :live="liveSasInspection3(12623)"></opq-memo>

    <subheadline code="titre-etape-3.2"></subheadline>

    <opq-catalogue code="interventions" v-model="sasInspection3.effectueInterventions" :live="liveSasInspection3(12644)"></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="mandat-etabli"
      v-model="sasInspection3.mandatEtabli"
      :live="liveSasInspection3(12624)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="mission-organisation"
      v-model="sasInspection3.missionOrganisation"
      :live="liveSasInspection3(12625)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="objectifs-intervention"
      v-model="sasInspection3.objectifsIntervention"
      :live="liveSasInspection3(12626)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="facteurs-incidence"
      v-model="sasInspection3.facteursIncidence"
      :live="liveSasInspection3(12627)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="communication-appropriee-questions"
      v-model="sasInspection3.communicationApproprieeQuestions"
      :live="liveSasInspection3(12628)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="objectifs-intervention-respect"
      v-model="sasInspection3.objectifsInterventionRespect"
      :live="liveSasInspection3(12629)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="renseignements-progres"
      v-model="sasInspection3.renseignementsProgres"
      :live="liveSasInspection3(12630)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="partage-information-pertinente"
      v-model="sasInspection3.partageInformationPertinente"
      :live="liveSasInspection3(12631)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="evaluation-evolution"
      v-model="sasInspection3.evaluationEvolution"
      :live="liveSasInspection3(12632)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="evaluation-evolution-outils"
      v-model="sasInspection3.evaluationEvolutionOutils"
      :live="liveSasInspection3(12633)"
    ></opq-catalogue>

    <opq-memo
      :opq-if="estEffectueInterventions && estEvaluationEvolutionOutils"
      code="evaluation-evolution-outils-details"
      v-model="sasInspection3.evaluationEvolutionOutilsDetails"
      :live="liveSasInspection3(12634)"
    ></opq-memo>

    <opq-memo
      :opq-if="estEffectueInterventions"
      code="evaluation-evolution-exemple"
      v-model="sasInspection3.evaluationEvolutionExemple"
      :live="liveSasInspection3(12635)"
    ></opq-memo>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="personnes-ressources"
      v-model="sasInspection3.personnesRessources"
      :live="liveSasInspection3(12636)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estEffectueInterventions"
      code="discussion-progres"
      v-model="sasInspection3.discussionProgres"
      :live="liveSasInspection3(12637)"
    ></opq-catalogue>

    <opq-memo
      :opq-if="estEffectueInterventions"
      code="nature-interventions"
      v-model="sasInspection3.natureInterventions"
      :live="liveSasInspection3(12638)"
    ></opq-memo>

    <subheadline code="titre-etape-3.3"></subheadline>

    <opq-file code="cv" :file="sasInspection3.cv" :live="liveSasInspection3(12639)"></opq-file>

    <opq-file
      code="formulaire-transmission-tiers"
      :file="sasInspection3.formulaireTransmissionTiers"
      :live="liveSasInspection3(12640)"
      optional
    ></opq-file>

    <opq-file code="dossier-client-complet" :file="sasInspection3.dossierClientComplet" :live="liveSasInspection3(12641)"></opq-file>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasInspection3() {
      return this.sas.sasInspection3
    },

    estEvaluationEvolutionOutils() {
      return this.estOui(this.sasInspection3.evaluationEvolutionOutils)
    },

    estEffectueInterventions() {
      return this.estOui(this.sasInspection3.effectueInterventions)
    }
  },

  methods: {
    liveSasInspection3(cle) {
      return { endpoint: "/sas-inspection-3/", cle: cle, fileId: this.sasInspection3.id }
    }
  }
}
</script>

<style>
</style>